import { useNavigate } from 'react-router-dom';
import { Header } from '../components/Header';
import { Button } from '../components/ui/button';
import { XCircle, ArrowLeft, Sparkles } from 'lucide-react';

export default function CheckoutCancelPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#FAFAFA]" data-testid="checkout-cancel-page">
      <Header />
      
      <main className="pt-32 pb-16 px-6 lg:px-8">
        <div className="max-w-2xl mx-auto text-center">
          <div className="w-20 h-20 mx-auto flex items-center justify-center border border-[#E5E5E5] mb-8">
            <XCircle className="w-10 h-10 text-[#A1A1AA]" />
          </div>
          
          <h1 
            className="text-5xl tracking-tight mb-4 text-[#0A0A0A]"
            style={{ fontFamily: 'Bodoni Moda, serif' }}
          >
            Checkout <span className="text-[#722F37]">Cancelled</span>
          </h1>
          
          <p className="text-[#525252] text-lg mb-12 max-w-md mx-auto">
            No worries! Your font is still available. You can complete your purchase anytime.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              onClick={() => navigate('/generator')}
              variant="outline"
              className="border-[#E5E5E5] hover:bg-[#0A0A0A] hover:text-white rounded-none px-8 py-6"
              data-testid="back-generator-btn"
            >
              <ArrowLeft className="w-4 h-4 mr-2" />
              Back to Generator
            </Button>
            <Button
              onClick={() => navigate('/generator')}
              className="bg-[#722F37] hover:bg-[#5A252C] rounded-none px-8 py-6"
              data-testid="create-new-btn"
            >
              <Sparkles className="w-4 h-4 mr-2" />
              Create New Font
            </Button>
          </div>
        </div>
      </main>
    </div>
  );
}
